'use client'
import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { useProductDetailPriceHistories } from './use-product-detail-price-histories'
import {
  CHART_CONFIG,
  HistoryChartComponent,
} from '@/shared/ui/history-chart-component'

interface HistoryChartProps extends HTMLAttributes<HTMLDivElement> {
  height: number
}

export const HistoryChart = ({
  className,
  height,
  ...props
}: HistoryChartProps) => {
  const { histories, highestData, lowestData, isPending, isDataEmpty } =
    useProductDetailPriceHistories()

  if (isPending) return null //TODO: loading UI 필요

  return (
    <HistoryChartComponent
      className={cn(className)}
      height={height}
      chartConfig={CHART_CONFIG}
      highestData={highestData}
      histories={histories}
      isDataEmpty={isDataEmpty}
      lowestData={lowestData}
      {...props}
    />
  )
}
